// Tipos para o Cadastro de Vidros N1

export interface IVidro {
  idVidro?: number;
  codigo: string;
  codigoInterno?: string;
  descricao: string;
  idSituacao: number;
  idStatus: number;
  idReferencia?: number;
  idLinha?: number;
  idTipoVidro: number; // Obrigatório
  tipoVidroDescricao?: string;
  
  // Propriedades Físicas
  espessura: number; // Obrigatório, decimal (mm)
  peso: number; // Obrigatório, decimal (kg/m²)
  fatorLH: number; // Obrigatório
  
  // Propriedades Funcionais
  controleSolar?: boolean;
  bloqueioRuido?: boolean;
  idArredondamento?: number; // Obrigatório
  arredondamentoDescricao?: string;
  
  // Mídia
  imagemUrl?: string;
  imagemNomeArquivo?: string;
  
  // Cores
  cores?: IVidroCor[];
  
  // Auditoria
  dataUltimaAtualizacao?: string;
  dataCriacao?: string;
  editavel?: boolean;
  excluido?: boolean;
}

export interface IVidroCor {
  id?: number;
  ordem: number; // Sequência (1, 2, 3, ...)
  idCor: number; // Obrigatório
  corDescricao: string; // Ex: "Azul", "Incolor"
  
  // Propriedades por Cor
  fs: number; // Fator Solar (0-100)
  ae: number; // Absorção de Energia (0-100)
  tt: number; // Transmissão Térmica (0-100)
  tl: number; // Transmissão Luminosa (0-100)
  bc: number; // Bloqueio de Calor (0-100)
  refInt: number; // Reflexão Interna (0-100)
  refExt: number; // Reflexão Externa (0-100)
  ativo: boolean; // Default: true
  
  idVidro?: number; // FK para Vidro
}

// Opções de Situação
// FASE 05 — 4ª validação/D3 2026-07-30: semântica legada — 3 = Disponível mercado,
// 4 = Indisponível (fora do fluxo), 5 = Homologado (estado novo do fluxo).
export const SITUACAO_OPTIONS = [
  { id: 1, label: 'Em edição' },
  { id: 2, label: 'Em homologação' },
  { id: 3, label: 'Disponível mercado' },
  { id: 4, label: 'Indisponível' },
  { id: 5, label: 'Homologado' },
];

// Opções de Status
export const STATUS_OPTIONS = [
  { id: 1, label: 'Ativo' },
  { id: 2, label: 'Descontinuado' },
  // FASE 05 — 2ª validação/PO 2026-07-24 (Frente 7, P5): "Inativo" removido do front.
];

// Opções Sim/Não
export const SIM_NAO_OPTIONS = [
  { value: true, label: 'Sim' },
  { value: false, label: 'Não' },
];

// Interface para selects de referência
export interface ISelectOption {
  id: number;
  nome: string;
  descricao?: string;
}

// Tab index
export type VidroTabIndex = 0 | 1;
export const VIDRO_TABS = ['GERAL', 'CORES'] as const;
